import React from "react";
import DocumentEmbeded from "src/components/embedTypes/basic/Document/DocumentEmbeded";
import { XMarkIcon } from "@heroicons/react/24/outline";
import SlideOver from "src/components/shared/SlideOver";
import Button from "src/components/form/Button";
import UploadedDocumentList from "src/components/shared/UploadedDocumentList";

const DocumentEmbedModal = ({ documentModalOpen, setDocumentModalOpen, content, activeTab }) => {
  return (
    <SlideOver
      size="5xl"
      title="Documents"
      description="View / download your documents or upload."
      showCloseIcon={false}
      isOpen={documentModalOpen}
      bodyClassName={activeTab === "view" ? "!p-0" : ""}
      handleClose={() => {
        setDocumentModalOpen(false);
      }}
      topActionButton={
        <div className="ml-auto flex gap-x-2">
          <Button
            type="button"
            buttonClasses="!h-11 !bg-highlightColor"
            buttonLabelClasses="text-sm"
            buttonLabel="Close"
            buttonIcon={XMarkIcon}
            buttonIconPosition="left"
            buttonFunction={() => setDocumentModalOpen(false)}
          />
        </div>
      }>
      <div className="flex-grow">
        {documentModalOpen &&
          (activeTab === "view" ? (
            <DocumentEmbeded
              name={content?.data?.group_name}
              documents={content?.data?.groupDocuments || []}
            />
          ) : (
            <UploadedDocumentList content={content?.data} />
          ))}
      </div>
    </SlideOver>
  );
};

export default DocumentEmbedModal;
